var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPremium = function SvgPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE36E",
    d: "M23.059 12c0 1.22 1.243 2.61.872 3.71-.389 1.138-2.262 1.564-2.983 2.511a2 2 0 0 0-.175.279c-.535 1-.49 2.576-1.402 3.211-.99.689-2.762-.011-3.953.358a2.9 2.9 0 0 0-.77.404C13.798 23.066 12.981 24 12 24c-.98 0-1.8-.936-2.648-1.527a2.9 2.9 0 0 0-.77-.404c-1.189-.372-2.963.331-3.953-.358-.912-.632-.867-2.212-1.402-3.211-.052-.1-.112-.19-.176-.279-.72-.947-2.596-1.373-2.982-2.511-.371-1.1.872-2.49.872-3.71S-.302 9.39.07 8.29C.458 7.152 2.331 6.726 3.051 5.78c.73-.959.576-2.792 1.578-3.49.99-.689 2.762.011 3.953-.358C9.726 1.575 10.723 0 11.998 0s2.271 1.575 3.42 1.933c1.189.372 2.963-.33 3.953.358 1.002.696.85 2.53 1.578 3.49.72.948 2.595 1.374 2.982 2.511.371 1.097-.872 2.489-.872 3.708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA39",
    d: "M11.998 20.234c4.752 0 8.605-3.687 8.605-8.234s-3.853-8.233-8.605-8.233S3.393 7.453 3.393 12s3.852 8.234 8.605 8.234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEEB",
    d: "m12.668 7.454.974 1.887a.75.75 0 0 0 .56.393l2.18.303c.613.086.857.805.415 1.22l-1.576 1.47a.7.7 0 0 0-.215.633l.372 2.076c.104.584-.536 1.028-1.085.752l-1.947-.98a.78.78 0 0 0-.694 0l-1.947.98c-.547.276-1.19-.17-1.085-.752l.372-2.076a.69.69 0 0 0-.216-.633l-1.575-1.47c-.443-.413-.199-1.134.415-1.22l2.179-.303a.74.74 0 0 0 .561-.393l.974-1.887c.272-.533 1.063-.533 1.338 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "premium_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPremium;